import React from 'react';
import PropTypes from 'prop-types';
import VehicleModel from 'commons-vehicle/Vehicle/models/VehicleModel.js';

import { LocaleService } from '@sm360/widget-commons-core-services';

import './VehicleTitleSpecs.scss';

const VehicleTitleSpecs = ({ className, url, vehicle, isAvailable }) => {
    const truthy = (value) => !!value;
    const specs = [
        vehicle.getOdometer(),
        vehicle.getDriveTrain(),
        vehicle.getTransmission(LocaleService),
        !!vehicle.cabSizeCode && LocaleService.capitalizeTitle(vehicle.cabSize[0]),
        !!vehicle.boxSizeCode && LocaleService.t('VEHICLE_TILE.BOX_SIZE', { boxSize: vehicle.boxSize[0] }),
    ].filter(truthy);
    const vehicleTitleSpecsClasses = isAvailable ? 'vehicle-title-specs' : 'vehicle-title-specs unavailable';

    return (
        <div className={vehicleTitleSpecsClasses}>
            <div className="vehicle-title">
                {url ? (
                    <a className={className} href={url}>
                        {vehicle.getYearMakeModelTrim()}
                    </a>
                ) : (
                    <span className={className}>{vehicle.getYearMakeModelTrim()}</span>
                )}
            </div>
            <ul className="vehicle-specs">{specs.map((spec) => <li className="is-light">{spec}</li>)}</ul>
        </div>
    );
};

VehicleTitleSpecs.defaultProps = {
    isAvailable: true,
    url: '',
};

VehicleTitleSpecs.propTypes = {
    vehicle: PropTypes.instanceOf(VehicleModel).isRequired,
    url: PropTypes.string,
    className: PropTypes.string.isRequired,
    isAvailable: PropTypes.bool,
};

VehicleTitleSpecs.displayName = 'VehicleTitleSpecs';

export default VehicleTitleSpecs;
